import { ThemeProvider } from '@oplog/express';
import * as React from 'react';
import { FC } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { KindeWrapper } from './auth/kinde';
import MainLayoutWrapper from './components/atoms/MainLayoutWrapper';
import { config } from './config';
import GlobalStyle from './GlobalStyle';
import i18n from './i18n';
import { getLocale } from './i18n/index';
import { routes } from './routers';
import { initStore } from './store/configure';
import theme from './theme';

export const store = initStore();

const App: FC = () => {
  const locale = getLocale(i18n.language);

  return (
    <Provider store={store}>
      <IntlProvider {...locale}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <KindeProvider
            clientId={config.auth.client_id}
            domain={config.auth.domain}
            redirectUri={config.auth.redirect_uri}
            logoutUri={config.auth.logout_uri}
            audience={config.auth.audience}
            scope={config.auth.scope}
          >
            <KindeWrapper>
              <ThemeProvider customTheme={theme as any}>
                <GlobalStyle />
                <Routes>
                {routes
                  .filter(r => r.enabled)
                  .map((route: any) => {
                    const RouteComponent = route.component;

                    if (route.protectedRoute && route.component) {
                      return (
                        <Route
                          key={route.key}
                          path={route.url}
                          element={<MainLayoutWrapper route={route} titleKey={route.titleKey} />}
                        />
                      );
                    }
                    if (!route.protectedRoute && route.component) {
                      return <Route key={route.key} path={route.url} element={<RouteComponent />} />;
                    }
                    throw Object.assign(new Error(`No component or render is available for route: ${route.url}`), {
                      code: 0,
                    });
                  })}
                </Routes>
              </ThemeProvider>
            </KindeWrapper>
          </KindeProvider>
        </BrowserRouter>
      </IntlProvider>
    </Provider>
  );
};

export default App;
